// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/plugins/sweetalert2/sweetalert2.min.css
// module id = 310
// module chunks = 0